import { mutationNames } from '@/store/storeKey'
import api from '@/modules/api'
import { HexCodeFromColor } from '@/modules/helper/index'

const state = {
  show: false,
  rendered: false,
  initialized: false,
  Icons: {
    IconInfo: [],
    objFolderIcons: []
  },
  Outlined: [],
  Filled: [],
  IconCategory: {},
  iconColor: '',
  resolve: null,
  reject: null
}

const getters = {
  visible: state => state.show,
  rendered: state => state.rendered,
  resolve: state => state.resolve,
  reject: state => state.reject,
  Icons: state => {
    return state.Icons
  },
  IconInfo: state => {
    return state.Icons.IconInfo
  },
  objFolderIcons: state => {
    return state.Icons.objFolderIcons
  },
  Outlined: state => {
    return state.Outlined
  },
  Filled: state => {
    return state.Filled
  },
  IconCategory: state => {
    return state.IconCategory
  },
  iconColor: state => state.iconColor
}

const mutations = {
  setShow (state, show) {
    if (show && !state.rendered) {
      state.rendered = true
    }
    state.show = show
  },
  setInitialized (state, initialized) {
    state.initialized = initialized
  },
  [mutationNames.SET_ICONS] (state, Icons) {
    state.Icons = Icons
  },
  [mutationNames.SET_CATEGORY_OUTLINED_ICONS] (state, Outlined) {
    state.Outlined = Outlined
  },
  [mutationNames.SET_CATEGORY_FILLED_ICONS] (state, Filled) {
    state.Filled = Filled
  },
  [mutationNames.SET_ICONCATEGORY] (state, IconCategory) {
    state.IconCategory = IconCategory
  },
  setCallbacks (state, callbacks) {
    state.resolve = callbacks.resolve
    state.reject = callbacks.reject
  },
  resetCallbacks (state) {
    state.resolve = null
    state.reject = null
  },
  setIconColor (state, color) {
    color = color ? color.replace('%23', '#') : color
    state.iconColor = color
  }
}

const actions = {
  async initIconGallery ({ dispatch, commit }) {
    let lan = localStorage.getItem('language')
    const icons = await api.icon.getAll(lan.toUpperCase())
    if (icons) {
      commit(mutationNames.SET_ICONS, icons)
      commit('setInitialized', true)
      dispatch('setSelectedIcon', 1)
    }
  },

  showGallery ({ commit, state, dispatch }, color) {
    return new Promise(async (resolve, reject) => {
      dispatch('showLoader', null, { root: true })
      if (!state.initialized) {
        await dispatch('initIconGallery')
      }
      commit('setIconColor', color)
      commit('setCallbacks', { resolve, reject })
      commit('setShow', true)
      dispatch('hideLoader', null, { root: true })
    })
  },

  hideGallery ({ commit, getters }) {
    const { visible, resolve } = getters
    if (visible) {
      resolve()
      commit('resetCallbacks')
      commit('setShow', false)
    }
  },

  async setDialogResult ({ commit, getters, rootGetters }, result) {
    const { resolve } = getters
    if (resolve) {
      let payload = {
        Name: result.name,
        Category: result.category.value,
        IsOutlined: result.type === 'outlined',
        Color: HexCodeFromColor(getters.iconColor),
        Subscription_GUID: rootGetters.subscription.Subscription_GUID
      }
      const response = await api.icon.uploadIcon(payload)
      resolve({ ...payload, Name: response })
      commit('resetCallbacks')
      commit('setShow', false)
    }
  },
  setSelectedIcon ({ commit, getters }, payload) {
    let IconCategory = {...getters.IconInfo.find(category => { return category.Id === payload })}
    let FilledIcons = {...getters.objFolderIcons.find(icons => { return icons.CategoryName === IconCategory.IconFolderName && icons.IconType === 'filled' })}
    let OutlinedIcons = {...getters.objFolderIcons.find(icons => { return icons.CategoryName === IconCategory.IconFolderName && icons.IconType === 'outlined' })}

    commit(mutationNames.SET_ICONCATEGORY, IconCategory)
    commit(mutationNames.SET_CATEGORY_OUTLINED_ICONS, OutlinedIcons)
    commit(mutationNames.SET_CATEGORY_FILLED_ICONS, FilledIcons)
  },
  setActiveIcon ({commit, getters}, payload) {
    if (payload.type === 1) {
      let FilledIconInfoobjClone = [ ...state.Filled.IconInfoobj ]
      const clone = FilledIconInfoobjClone.map(icons => {
        if (icons.FileName === payload.name) {
          icons.IsActive = true
        } else {
          icons.IsActive = false
        }
        return Object.assign({}, icons)
      })
      state.Filled.IconInfoobj = clone
      commit(mutationNames.SET_CATEGORY_FILLED_ICONS, state.Filled)
    } else {
      let OutlinedIconInfoobjClone = [ ...state.Outlined.IconInfoobj ]
      const clone = OutlinedIconInfoobjClone.map(icons => {
        if (icons.FileName === payload.name) {
          icons.IsActive = true
        } else {
          icons.IsActive = false
        }
        return Object.assign({}, icons)
      })
      state.Outlined.IconInfoobj = clone
      commit(mutationNames.SET_CATEGORY_OUTLINED_ICONS, state.Outlined)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/iconGallery.js